export const SPLIT_TRAFFIC_TYPES = {
    allUsers: 'user',
    authenticatedUser: 'auth_user',
};

export const SPLIT_CONTROL_TREATMENT = 'control';
